<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation">
        <v-toolbar text color="white">
            <v-toolbar-title>
                <v-text-field
                    label="Поиск"
                    solo
                    text
                    single-line
                    class="mb-0"
                    prepend-icon="search"
                    hide-details/>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="addTgMessage">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-list class="v-list--booking" v-if="getTgMessages.length > 0">
            <v-list-item
                :key="msg.id"
                @click="editTgMessage(msg.id)"
                v-for="msg in getTgMessages"
                :class="`v-list--booking_state f-width ${$route.params.tgMessageId === msg.id ? 'active' : ''}`"
            >
                <v-list-item-title v-text="msg.name"/>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Empty from '../../../components/Loader/Empty'

    export default {
        name: 'tgMessageNavigation',
        components: { Empty },
        methods: {
            addTgMessage () {
                this.$router.push({ name: 'addTgMessage' })
            },
            editTgMessage (tgMessageId) {
                this.$router.push({
                    name: 'editTgMessage',
                    params: { tgMessageId }
                })
            }
        },
        computed: mapGetters([
            'getTgMessages'
        ])
    }
</script>
